import {useSelector} from 'react-redux';
import {RootState} from '../../../redux/store.type';

/* True when the order holds a subscription ticket — the actions stay the same, the wording changes */
export const useIsSubscription = (): boolean =>
    useSelector((state: RootState) => Boolean(state.eTicket.data?.tickets?.some(ticket => ticket.subscription)));
